import React, { useEffect, useState } from 'react'
import {  useBnsMeiJieWenDangUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions, Space, Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import DocEdit from './DocEdit';
function DocDesc(props) {
    const [info,setInfo] = useState({
      bmjwd_name:''
    })
    const {data,isSuccess} = useBnsMeiJieWenDangUpdateQuery({bmjwd_id:props.bmjwd_id},{skip:!props.bmjwd_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bmjwd_dept_id:data.Result.bmjwd_dept_id,        
                    bmjwd_dept_name:data.Result.bmjwd_dept_name,                        
                    bmjwd_ctime:data.Result.bmjwd_ctime,                                       
                    bmjwd_cname:data.Result.bmjwd_cname,                                       
                    bmjwd_riqi:data.Result.bmjwd_riqi,                                                
                    bmjwd_name:data.Result.bmjwd_name,                                                
                    bmjwd_content:data.Result.bmjwd_content,                                                
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'bmj_name',
            label:'媒介',
            children:props.bmj_name,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'4',
            label:'名称',
            children:info.bmjwd_name,
            contentStyle:{fontSize:"18px"},
            span:3
        },
       
        {
            key:'bmjwd_content',
            label:'备注',
            children:<div  dangerouslySetInnerHTML={{__html:info.bmjwd_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'7',
            label:'部门',
            children:<>{info.bmjwd_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.bmjwd_cname+info.bmjwd_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'9',
            label:'操作',
            children:   <Space>
                              <DocEdit
                                  bmjwd_id={props.bmjwd_id}
                                  bmj_id={props.bmj_id}
                              />  
                        </Space>,
        },
    ]
    return (
        <>
            {info.bmjwd_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='媒介文档'
                                        num={props.bmjwd_id}                        
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default DocDesc